/* V89 — BENDRA RAIL INFRASTRUKTŪRA
 *
 * Vienas horizontalaus slinkimo sluoksnis, kurį naudoja:
 *   H03 homepage atsiliepimai
 *   P03 pilnų žaidimų galerija
 *   E03 papildymų galerija
 *   R02 atsiliepimų puslapis
 *   H10 Game Night (turi savo pasakojimo logiką, rail tik slinkimui)
 *
 * KODĖL VIENAS SLUOKSNIS
 * Penkios atskiros karuselės reikštų penkis skirtingus klaidų rinkinius.
 * Čia viskas vienoje vietoje: drag, klaviatūra, lazy-load, reduced-motion.
 *
 * PAMATINIS PRINCIPAS: NATIVE SCROLL
 * Slinkimą daro naršyklė (`overflow-x: auto` + `scroll-snap`). JS tik
 * PRIDEDA patogumo: pelės tempimą, rodykles, taškus. Todėl:
 *   - be JS rail vis tiek slenka pirštu ir klaviatūra;
 *   - momentum ir inercija yra native, ne imituota;
 *   - CLS nekyla, nes elementai nėra perpozicionuojami.
 *
 * LAZY-LOAD
 * Nuotraukos už matomos srities gauna `loading="lazy"` markup'e. JS
 * papildomai kelia `fetchpriority` tik pirmam matomam elementui.
 * Todėl 20+ kortelių rail nesiunčia 20 paveikslėlių iš karto.
 *
 * REDUCED-MOTION
 * `prefers-reduced-motion` -> `scroll-behavior` tampa `auto`, todėl
 * rodyklės peršoka iš karto, be slinkimo animacijos. Auto-slinkimo
 * (H03 „slow drift") tokiu atveju NEPALEIDŽIAME visai.
 *
 * IDEMPOTENT INIT
 * `dataset.railReady` — Theme Editor perkraunant sekciją listeneriai
 * ir stebėtojai nesidubliuoja. `shopify:section:unload` viską išvalo.
 */
(function () {
  'use strict';

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Tekstai paduodami per `<html data-rail-*>`, kad vertimai liktų
     locale failuose, o JS neturėtų antro tiesos šaltinio. */
  var D = document.documentElement.dataset;
  var RAIL_PAUSE = D.railPause || 'Stabdyti';
  var RAIL_PLAY = D.railPlay || 'Paleisti';
  var RAIL_PAUSE_L = D.railPauseLabel || 'Sustabdyti automatinį judėjimą';
  var RAIL_PLAY_L = D.railPlayLabel || 'Paleisti automatinį judėjimą';

  function Rail(root) {
    if (root.dataset.railReady === '1') return;
    root.dataset.railReady = '1';

    var track = root.querySelector('[data-rail-track]');
    if (!track) return;

    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');
    var live = root.querySelector('[data-rail-live]');
    var items = function () { return [].slice.call(track.children); };

    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var opts = ac ? { signal: ac.signal } : false;
    root._railAbort = ac;

    /* ---------- Rodyklių būsena ---------- */
    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      var w = first.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      /* Slenkame per tiek kortelių, kiek telpa, bet bent per vieną. */
      var fit = Math.max(1, Math.floor(track.clientWidth / (w + gap)));
      return (w + gap) * fit;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= max;
      /* Rodyklė be paskirties yra klaidinanti — ją išjungiame, o ne
         slepiame, kad layout nešokinėtų. */
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      root.classList.toggle('is-start', atStart);
      root.classList.toggle('is-end', atEnd);
      if (max <= 0) root.classList.add('is-static');
      else root.classList.remove('is-static');
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: RM ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); }, opts);
    if (next) next.addEventListener('click', function () { go(1); }, opts);

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true, signal: ac ? ac.signal : undefined });

    /* ---------- Pelės tempimas ----------
       Tik pelei. Liesti touch nereikia — ten native scroll geresnis
       už bet kokią imitaciją. */
    var down = false, sx = 0, sl = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = 0;
      sx = e.clientX; sl = track.scrollLeft;
      track.classList.add('is-dragging');
    }, opts);

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      moved = Math.abs(dx);
      track.scrollLeft = sl - dx;
    }, opts);

    function endDrag(e) {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      /* Jei buvo tempiama, nuorodos paspaudimą atšaukiame — kitaip
         vartotojas netyčia nueitų į produktą vietoj slinkimo. */
      if (moved > 6 && e && e.target) {
        var a = e.target.closest && e.target.closest('a,button');
        if (a) {
          var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          a.addEventListener('click', kill, { capture: true, once: true });
        }
      }
    }
    track.addEventListener('pointerup', endDrag, opts);
    track.addEventListener('pointerleave', endDrag, opts);
    track.addEventListener('pointercancel', endDrag, opts);

    /* ---------- Klaviatūra ----------
       Native scroll konteineris su `tabindex="0"` jau palaiko rodykles,
       bet mes pridedame Home/End ir žingsnį per kortelę. */
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'Home') { e.preventDefault(); track.scrollTo({ left: 0, behavior: RM ? 'auto' : 'smooth' }); }
      else if (e.key === 'End') { e.preventDefault(); track.scrollTo({ left: track.scrollWidth, behavior: RM ? 'auto' : 'smooth' }); }
    }, opts);

    /* Fokusas kortelėje turi ją parodyti, o ne palikti už krašto. */
    track.addEventListener('focusin', function (e) {
      var el = e.target.closest && e.target.closest('[data-rail-item]');
      if (!el) return;
      var r = el.getBoundingClientRect(), t = track.getBoundingClientRect();
      if (r.left < t.left || r.right > t.right) {
        el.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: RM ? 'auto' : 'smooth' });
      }
    }, opts);

    /* ---------- Lėtas dreifas (tik jei sekcija to prašo) ---------- */
    var driftMs = parseInt(root.dataset.railDrift, 10);
    var driftDirection = root.dataset.railDirection || 'left';
    /* V119 — DREIFAS PERRAŠYTAS Į requestAnimationFrame.

       Sena versija buvo `setInterval` + `scrollBy(1px)`. Prie 60 ms
       intervalo tai duoda 16 šuolių per sekundę po visą pikselį, o
       intervalo tikslumas naršyklėje plaukioja. Rezultatas — trūkčiojantis,
       „chaotiškas" judesys, kurį savininkas ir pastebėjo.

       Dabar pozicija skaičiuojama pagal PRAĖJUSĮ LAIKĄ ir laikoma
       trupmeniniame kintamajame, o `scrollLeft` priima trupmenas. Judesys
       tampa tolygus, nepriklausomas nud kadrų dažnio.

       `data-rail-drift` reikšmė lieka ta pati (ms), tik dabar ji verčiama
       į greitį: mažesnė reikšmė = greičiau, kaip ir anksčiau.

       CIKLAS: jei bėgelis pažymėtas `data-rail-loop`, turinys jame yra
       PADVIGUBINTAS, todėl pasiekus pusę galima grįžti į 0 ir siūlės
       nesimato. Kitu atveju sustojama gale — geriau nei staigus šuolis. */
    var driftPos = 0, driftRAF = null, driftLast = 0;
    var loopMode = root.hasAttribute('data-rail-loop');

    function driftStep(ts) {
      if (!driftLast) driftLast = ts;
      var dt = Math.min(ts - driftLast, 64);
      driftLast = ts;
      if (!document.hidden) {
        /* `data-rail-drift` reikšmė yra ms vienam pikseliui — tokia pat
           prasmė, kaip senajame `setInterval` variante. */
        var pxPerMs = 1 / Math.max(driftMs, 1);
        driftPos += (driftDirection === 'left' ? 1 : -1) * pxPerMs * dt;
        var span = loopMode ? track.scrollWidth / 2
                            : track.scrollWidth - track.clientWidth;
        if (span > 0) {
          if (driftDirection === 'left' && driftPos >= span) {
            driftPos = loopMode ? driftPos - span : 0;
          } else if (driftDirection === 'right' && driftPos <= 0) {
            driftPos = loopMode ? driftPos + span : span;
          }
        }
        track.scrollLeft = driftPos;
      }
      driftRAF = requestAnimationFrame(driftStep);
    }

    function startDrift() {
      if (RM || !driftMs || driftMs <= 0) return;
      /* V125b — PAUZĖ GYVENA ANT `track`, NE UŽDARYME.

         Išmatuota: paspaudus mygtuką juosta NESUSTODAVO — `is-drifting`
         likdavo, o `scrollLeft` toliau augo (58 -> 83 per 1,5 s).

         Priežastis: atsiliepimų juostos inicializuojamos DU KARTUS —
         antrą kartą po `fetch`, kai korteles sudeda `mz-reviews.js`.
         Tada atsiranda antras dreifo ciklas su savo `paused` kintamuoju,
         o mygtukas stabdo tik pirmąjį.

         Būsena ant DOM elemento yra bendra visiems ciklams, todėl
         antras ciklas nebepasileidžia. */
      if (track.dataset.railPaused === '1') return;
      if (track.scrollWidth <= track.clientWidth) return;
      stopDrift();
      track.classList.add('is-drifting');
      driftPos = track.scrollLeft;
      if (driftDirection === 'right' && driftPos <= 0) {
        var initSpan = loopMode ? track.scrollWidth / 2 : track.scrollWidth - track.clientWidth;
        if (initSpan > 0) { driftPos = initSpan; track.scrollLeft = driftPos; }
      }
      driftLast = 0;
      driftRAF = requestAnimationFrame(driftStep);
    }
    function stopDrift() {
      if (driftRAF) { cancelAnimationFrame(driftRAF); driftRAF = null; }
      driftLast = 0;
      track.classList.remove('is-drifting');
    }

    /* ---------- V125 · REV-01, HP-08 — MATOMAS STABDYMO VALDIKLIS ----------
       Iki šiol judėjimą buvo galima sustabdyti tik pele arba fokusu.
       Klaviatūros ar jutiklinio ekrano naudotojas jokio būdo neturėjo, o
       WCAG 2.2.2 reikalauja aiškaus mechanizmo turiniui, kuris juda
       ilgiau nei 5 s.

       Mygtukas kuriamas TIK toms juostoms, kurios iš tikrųjų juda —
       `driftMs > 0` ir turinys platesnis už rėmą. Kur judėjimo nėra,
       nekuriamas ir valdiklis, kad neatsirastų mygtukas, kuris nieko
       nedaro.

       `paused` yra rankinis režimas: jį įjungus `mouseleave` nebepaleis
       judėjimo atgal. Kitaip mygtukas atrodytų sulūžęs — sustabdai, o
       patraukus pelę vėl juda. */
    var toggle = null;
    function isPaused() { return track.dataset.railPaused === '1'; }
    function setPaused(v) {
      if (v) track.dataset.railPaused = '1';
      else delete track.dataset.railPaused;
    }

    function setToggle() {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', isPaused() ? 'true' : 'false');
      toggle.textContent = isPaused() ? RAIL_PLAY : RAIL_PAUSE;
      toggle.setAttribute('aria-label', isPaused() ? RAIL_PLAY_L : RAIL_PAUSE_L);
    }

    function buildToggle() {
      if (RM || !driftMs || driftMs <= 0) return;
      if (track.scrollWidth <= track.clientWidth) return;
      if (root.querySelector('[data-rail-toggle]')) return;
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'rail__toggle';
      toggle.setAttribute('data-rail-toggle', '');
      setToggle();
      toggle.addEventListener('click', function () {
        setPaused(!isPaused());
        if (isPaused()) stopDrift(); else startDrift();
        setToggle();
      });
      root.appendChild(toggle);
    }

    root.addEventListener('mouseenter', stopDrift, opts);
    root.addEventListener('mouseleave', function () { if (!isPaused()) startDrift(); }, opts);
    root.addEventListener('focusin', stopDrift, opts);
    track.addEventListener('pointerdown', stopDrift, opts);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopDrift(); else if (!isPaused()) startDrift();
    }, opts);

    buildToggle();

    /* Turinys gali atkeliauti vėliau (atsiliepimai per `fetch`), todėl
       tuo metu `scrollWidth` dar lygus `clientWidth` ir valdiklio
       sąlyga neišsipildo. Išmatuota: 3 judančios juostos, bet tik
       1 valdiklis. Todėl bandoma dar kartą, kai turinys pasikeičia. */
    if ('ResizeObserver' in window) {
      var toggleRO = new ResizeObserver(function () { buildToggle(); });
      toggleRO.observe(track);
    }
    if ('MutationObserver' in window) {
      new MutationObserver(function () { buildToggle(); })
        .observe(track, { childList: true });
    }

    /* ---------- Lazy-load pagalba ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var img = en.target.querySelector('img[data-rail-src]');
          if (img) { img.src = img.dataset.railSrc; img.removeAttribute('data-rail-src'); }
          io.unobserve(en.target);
        });
      }, { root: track, rootMargin: '400px' });
      items().forEach(function (n) { io.observe(n); });
      root._railIO = io;
    }

    /* ---------- Turinys gali atkeliauti VĖLIAU ----------
       Atsiliepimai ir kai kurios galerijos įrašomos į DOM asinchroniškai
       (fetch -> render). Rail init įvyksta anksčiau, todėl pirmasis
       `sync()` mato tuščią bėgelį, nusprendžia „telpa" ir IŠJUNGIA
       rodykles.

       Būtent taip ir nutiko v91: bėgelis buvo 5360 px pločio prie
       1325 px lango, bet rodyklės liko `disabled`.

       `MutationObserver` seka vaikų pokyčius ir persiskaičiuoja. Kartu
       naujiems elementams pritaikomas lazy-load stebėjimas. */
    var mo = null;
    if (typeof MutationObserver === 'function') {
      var moTick = false;
      mo = new MutationObserver(function () {
        if (moTick) return;
        moTick = true;
        requestAnimationFrame(function () {
          moTick = false;
          sync();
          /* V120 — DREIFAS TURI STARTUOTI IR PO VĖLYVO TURINIO.
             Rasta matuojant: antra atsiliepimų juosta stovėjo vietoje.
             `startDrift()` per init'ą pamatydavo TUŠČIĄ bėgelį
             (`scrollWidth <= clientWidth`) ir grįždavo nieko nedaręs, o
             atėjus kortelėms niekas jo nebepaleisdavo. Dabar kiekvienas
             turinio pokytis bandymą pakartoja; `startDrift` pats
             pasitikrina, ar jau yra ką slinkti. */
          if (!driftRAF) startDrift();
          if (root._railIO) {
            items().forEach(function (n) {
              if (!n.dataset.railSeen) { n.dataset.railSeen = '1'; root._railIO.observe(n); }
            });
          }
          startDrift();
        });
      });
      mo.observe(track, { childList: true });
      root._railMO = mo;
    }

    /* ---------- INKREMENTINIS DOKROVIMAS ----------
       Planas prašo 20+ atsiliepimų, bet `per_load` schemos riba yra 16,
       o jos kėlimas šablone jau vieną kartą sugriovė `index.json`
       (v89: „Setting 'per_load' can't be greater than 16").

       Todėl kiekio nedidiname konfigūracijoje. Vietoj to bėgelis
       DOKRAUNA kitą porciją, kai vartotojas prisiartina prie pabaigos.
       Tai ir yra tai, ko planas prašo: lazy render, o ne visko iš karto.

       Naudojamas esamas „rodyti daugiau" mygtukas, todėl kortelių
       generavimo logikos neliečiame ir dublikatų neatsiranda. */
    /* V94: „rodyti daugiau" mygtukas yra SEKCIJOJE, ne bėgelyje.
       v93 ieškojau jo `root` viduje, todėl dokrovimas niekada
       nesuveikė. Ieškome nuo artimiausios sekcijos. */
    var scopeEl = root.closest('.shopify-section, section') || document;
    var moreBtn = scopeEl.querySelector('[data-reviews-more]');
    if (moreBtn) {
      var loading = false;
      track.addEventListener('scroll', function () {
        if (loading || moreBtn.hidden) return;
        var left = track.scrollWidth - track.clientWidth - track.scrollLeft;
        if (left > track.clientWidth) return;
        loading = true;
        moreBtn.click();
        /* Trumpa pauzė, kad vienas slinkimas nesukeltų kelių krovimų. */
        setTimeout(function () { loading = false; }, 400);
      }, { passive: true, signal: ac ? ac.signal : undefined });
    }

    root._railStop = stopDrift;
    sync();
    startDrift();
    window.addEventListener('resize', sync, opts);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rail]').forEach(Rail);
  }

  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-rail]') : null;
    if (!r) return;
    if (r._railAbort) { try { r._railAbort.abort(); } catch (err) {} }
    if (r._railIO) { try { r._railIO.disconnect(); } catch (err) {} }
    if (r._railMO) { try { r._railMO.disconnect(); } catch (err) {} }
    if (r._railStop) { try { r._railStop(); } catch (err) {} }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
